import { BehaviorSubject, filter, map, Observable, of } from 'rxjs';
import { CrudItemEditorDetails, CrudManagerMode, CrudModeAndItem } from '../crud-manager';
import { CrudManagerUtils } from '../crud-manager/crud-manager.utils';
import { DEFAULT_EDITOR_DEFINITION_ID, IdItemModel, ItemEditMode, ItemModelActionData, ModelCtor } from '@core/shared/model';
import { CrudFormServiceFactory } from '@common/crud/frontend-shared';
import { FormServiceSaveHandlerEditableApiItem, FsOnAfterSaveEvent } from '@common/forms/frontend-shared';
import { DestroyRef, inject } from '@angular/core';
import { crudManagerDefaults } from '../crud.config';
import { CrudServiceFactory, takeWhileAlive } from '@core/frontend-shared';
import * as deepmerge from 'deepmerge';
import { convertToBehaviorSubject, isPlainObject, MakeRequired } from '@core/shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@common/crud/frontend-shared";
export let CrudItemViewServiceCustom = /*#__PURE__*/(() => {
  class CrudItemViewServiceCustom {
    get itemEditorDetails() {
      return this.itemEditorDetails$.getValue();
    }
    get contextGroups$() {
      return this.modeAndItem$.pipe(map(({
        mode
      }) => CrudManagerUtils.getContextGroups(mode)));
    }
    get Model() {
      return this.config.Model;
    }
    get editorConfig() {
      return this.config.editorConfig;
    }
    get enableEdit() {
      return true;
    }
    constructor(config, crudServiceFactory, crudFormServiceFactory) {
      this.crudServiceFactory = crudServiceFactory;
      this.crudFormServiceFactory = crudFormServiceFactory;
      this.destroyRef = inject(DestroyRef);
      this.modeAndItem$ = new BehaviorSubject(null);
      this.itemEditorDetails$ = convertToBehaviorSubject(null)(this.modeAndItem$.pipe(filter(modeAndItem => {
        return modeAndItem && !!modeAndItem.item && !!modeAndItem.mode;
      }), takeWhileAlive(this.destroyRef), map(current => {
        const crudInstructions = this.editorConfig.instructions;
        const instructions = Array.isArray(crudInstructions) ? crudInstructions : crudInstructions[this.config.mode];
        return {
          formService: this.config.formService || this._createFormService(current),
          instructions,
          mode: this.config.mode,
          initialItem: current.item
        };
      })));
      this.config = deepmerge({
        editorDefinition: DEFAULT_EDITOR_DEFINITION_ID,
        editorConfig: {
          ...crudManagerDefaults.editor
        },
        itemActions: [],
        innerFormTemplate: null
      }, config, {
        // Fix MPF-244 - config may contain instructions which are instances of specific classes. they must not be merged!
        isMergeableObject: isPlainObject
      });
      this.crudService = crudServiceFactory.useDestroyRef(inject(DestroyRef)).createCrudService(config.Model).useCrudEndpoint(config.crudEndpoint);
      this.configurateModeAndItem();
    }
    // equivalent to CrudManagerService.configurateModeAndItem.
    // but instead of reacting to route changes, this will solve mode and item based on the static config.
    configurateModeAndItem() {
      if (['edit', 'view'].includes(this.config.mode)) {
        if (!this.config.itemId) {
          throw new Error('CrudItemViewServiceCustom Error: config.itemId must be set when using ItemEditModes edit, view, clone.');
        }
        this.crudService.readOne(this.config.itemId).subscribe({
          next: item => {
            this.modeAndItem$.next({
              item,
              mode: this.config.mode
            });
          }
          // error: () => {
          // 	this.messages
          // 		.create(getItemModelText('itemNotExists', { id:state.id }))
          // 		.setSeverity('warn');
          // 	this.router.navigate(['../'], {
          // 		relativeTo: state.route,
          // 	});
          // },
        });
      } else if (this.config.mode === 'new') {
        const item = this.crudService.createNew();
        this.modeAndItem$.next({
          item,
          mode: this.config.mode
        });
      } else {
        throw new Error('CrudItemViewServiceCustom Error: the configurated mode is unsupported: ' + this.config.mode);
      }
    }
    getPageTitle() {
      return {
        setPageTitleForListView: false,
        setPageTitleForItemView: false
      };
    }
    setPageTitle(title) {}
    navigateTo(requestedView, param) {
      throw new Error('CrudItemViewServiceCustom does not support navigateTo().');
    }
    reload(onlyCurrentItem) {
      this.configurateModeAndItem();
    }
    getInnerFormTemplate() {
      return this.config.innerFormTemplate;
    }
    getItemActions$(forSpecificMode) {
      if (forSpecificMode) throw new Error('Getting item actions for specific modes is not supported by CrudItemViewServiceCustom!');
      return of(this.config.itemActions);
    }
    _createFormService(modeAndItem) {
      let formService = this.crudFormServiceFactory.useDestroyRef(this.destroyRef).createCrudFormService(this.Model);
      console.log('created formService #' + formService._id + ' with edit mode=' + modeAndItem.mode);
      formService.setEditMode(modeAndItem.mode);
      formService.enableAutoSave(this.config.editorConfig.autoSave);
      formService.setInitialValue(modeAndItem.item);
      formService.setEditorDefinition(this.config.editorDefinition || DEFAULT_EDITOR_DEFINITION_ID);
      const customizeCb = this.config.customizeFormService;
      if (customizeCb) formService = customizeCb(formService, modeAndItem.item);
      formService.setSaveHandler(FormServiceSaveHandlerEditableApiItem, h => h.setService(this.crudService));
      if (this.config.onAfterSave) {
        formService.events$.pipe(filter(e => e instanceof FsOnAfterSaveEvent), takeWhileAlive(this.destroyRef)).subscribe(event => {
          this.config.onAfterSave(event);
        });
      }
      formService.initialize();
      return formService;
    }
    static {
      this.ɵfac = function CrudItemViewServiceCustom_Factory(__ngFactoryType__) {
        i0.ɵɵinvalidFactory();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: CrudItemViewServiceCustom,
        factory: CrudItemViewServiceCustom.ɵfac
      });
    }
  }
  return CrudItemViewServiceCustom;
})();